import { useState, useEffect } from 'preact/hooks'

// alter delay to test functionality
export default function useHydrated(delay = 0) {
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    if(delay) {
      const timer = setTimeout(() => {
        setHydrated(true)
      }, delay)

      return () => clearTimeout(timer)
    } else {
      setHydrated(true)
    }

  }, [delay])

  return hydrated
}
